import { Component, Input } from '@angular/core';
import { ReferendumStatusColumnDef, ReferendumStatus } from './referendum-status.model';
import { ElectionDto } from '@shared/clients/api.generated';

@Component({
  selector: 'valg-dk-referendum-status',
  templateUrl: './referendum-status.component.html'
})
export class ReferendumStatusComponent {
  @Input() data: ReferendumStatus[] = [];
  @Input() election?: ElectionDto;

  
  referendumStatusColumnDef = ReferendumStatusColumnDef;
}
